import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowSelectorDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19 8.998H5l7 6z" })
});
export default SvgArrowSelectorDown;
